module.exports = __webpack_public_path__ + "media/images/active_material/icons/secret-39c56b0b3dcf4caba832429deb820bd4.svg";